import { gql } from '@apollo/client/core'

export const CREATE_CUSTOMER_PORTAL = gql`
  mutation createCustomerPortal($input: CreateCustomerPortalInput!) {
    createCustomerPortal(input: $input) {
      portalUrl
      errors {
        message
        path
      }
    }
  }
`
